import { useAuth } from "react-oidc-context";

function TestView({ auth }) {
  if (!auth.isAuthenticated) {
    return <p>Not authenticated</p>
  }
  return (
    <div>
      <p>User: {auth.user.profile.email}</p>
      <p>Access_token: {auth.user.access_token}</p>
      <p>Id_token: {auth.user.id_token}</p>
      <p>Expires_at: {auth.user.expires_at}</p>
    </div>
  );
}

function Main() {
  const auth = useAuth();

  return (
    <div>
      <h1>TTD Solution Engineering Web</h1>
      <hr />
      <div><TestView auth={auth} /></div>
    </div>
  )
}

export default Main